export const setCustomInterval = (callback: () => void, duration: number) => {
  const timeoutId = window.setInterval(callback, duration);
  return () => window.clearInterval(timeoutId);
};
